// @ts-check
import React from 'react';

import LoaderCircle from '@liquidweb-dev/undercurrent/icons/animated/LoaderCircle';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** @param {import('@liquidweb-dev/undercurrent/Stack').StackProps} props */
const SuspenseFallback = ({ children, sx, ...rest }) => (
	<Stack
		sx={combineSx(
			{
				justifyContent: 'center',
				alignItems: 'center',
				flexGrow: 1,
			},
			sx,
		)}
		{...rest}
	>
		<LoaderCircle sx={({ size }) => ({ height: size.lg, width: size.lg })} />

		{children}
	</Stack>
);

export default SuspenseFallback;
